export enum GoogleAnalyticsDimensions {
  XCoordinate = 'dimension1',
  YCoordinate = 'dimension2',
}
